export const enHepTranslations = {
  hepPage: {
    languages: {
      en: 'English',
      he: 'Hebrew',
      ro: 'Romanian',
      ru: 'Russian',
      es: 'Spanish',
      uk: 'Ukrainian',
    },
    filterLabels: {
      equipment: 'Equipment',
      language: 'Language',
      createdBy: 'Created by',
    },
    createdByOptions: {
      onestep_content: 'OneStep templates',
      custom: 'Custom templates',
      created_by_me: 'Created by me',
    },
    history: {
      title: 'History & Feedback',
      emptyStateTitle: 'No exercises recorded yet',
      loadError: 'Failed to load history',
      sets: '{{count}} sets',
      reps: '{{count}} reps',
      holdSec: '{{count}} sec hold',
      patientFeedback: 'Patient feedback:',
      difficulty: 'Difficulty:',
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
      veryHard: 'Very Hard',
    },
    common: {
      instructions: 'Instructions',
      equipment: 'Equipment',
      categories: 'Categories',
    },
    libraryPanel: {
      title: 'Library',
      search: 'Search',
      filters: 'Filters',
      removeFilter: 'Remove {{label}} filter',
      tabs: {
        templates: 'Templates',
        exercises: 'Exercises',
      },
      templates: {
        searchAriaLabel: 'Search templates',
        loadError: 'Failed to load templates',
        exercises: '{{count}} exercises',
        viewTemplate: 'View template',
        addTemplate: 'Add template',
        custom: 'Custom',
      },
      exercises: {
        searchAriaLabel: 'Search exercises',
        loadError: 'Failed to load exercises',
        added: 'Added',
      },
      emptyState: {
        title: 'No results were found',
        description: 'Try a different search term or clear your filters.',
      },
    },
    header: {
      activeExercises_one: '{{count}} exercise',
      activeExercises_other: '{{count}} exercises',
      lastModified: 'Last modified: {{date}}',
      copyForEmr: 'Copy for EMR',
      print: 'Print',
      deleteAll: 'Delete all exercises',
      saveAsTemplate: 'Save as a new template',
      moreOptions: 'More options',
      language: 'Language',
      deleteAllDialog: {
        title: 'Delete all exercises',
        message:
          'Are you sure you want to delete all exercises from this program? This can not be undone.',
        cancel: 'Cancel',
        confirm: 'Delete all',
      },
    },
    templateBuilder: {
      deleteTemplateDialog: {
        title: 'Delete Template',
        message:
          'Are you sure you want to delete this template? The template will be removed from your organizational custom templates. This can not be undone.',
        cancel: 'Cancel',
        confirm: 'Delete',
      },
      saveAsTemplateModal: {
        title: 'Save as a new template',
        language: 'Language',
        selectLanguage: 'Select language',
        templateNamePlaceholder: 'Template name',
        descriptionPlaceholder: 'Add description',
        warningBanner: "Creating a template adds it to your organization's shared templates.",
        cancel: 'Cancel',
        createTemplate: 'Create template',
        createSuccess: 'Template created successfully',
      },
    },
    emrText: {
      programAssigned: 'A home exercise program was assigned to the patient.',
      programIncludes: 'This home exercise program includes the following {{count}} {{exercise}}:',
      sets_one: '{{count}} set',
      sets_other: '{{count}} sets',
      reps_one: '{{count}} rep',
      reps_other: '{{count}} reps',
      untitledExercise: 'Exercise',
      dosage: '{{sets}} x {{reps}}',
    },
    personalMessage: {
      addMessage: 'Add a personal message',
      placeholder: 'Add a personal message...',
      readMore: 'Read more',
      readLess: 'Read less',
    },
    exerciseList: {
      loadError: 'Failed to load exercises',
      emptyState: {
        title: 'Drag exercises here',
        subtitle: "Build {{name}}'s program by dragging exercises or templates from the library",
        subtitleGeneric: 'Build the program by dragging exercises or templates from the library',
      },
    },
    errors: {
      removeExercise: 'Failed to remove exercise',
      deleteAllExercises: 'Failed to delete all exercises',
      reorderExercises: 'Failed to reorder exercises',
      addExercise: 'Failed to add exercise',
      addTemplate: 'Failed to add template',
      updateExercise: 'Failed to update exercise',
      updateMessage: 'Failed to save message',
      createTemplate: 'Failed to create template',
      deleteTemplate: 'Failed to delete template',
      previewExercise: 'Failed to load exercise',
    },
    exercisePreview: {
      description: 'Exercise preview',
      insertExercise: 'Add Exercise',
      playVideo: 'Play video',
      tips: 'Tips',
    },
    templatePreview: {
      description: 'Template preview',
      descriptionLabel: 'Description:',
      exercisesLabel: 'Exercises:',
      exercisesLoadError: 'Failed to load exercises',
      exercisesEmpty: 'No exercises in this template',
      addExercises: 'Add {{count}} Exercises',
      deleteTemplate: 'Delete template',
    },
    exerciseCard: {
      viewExercise: 'View exercise',
      editExercise: 'Edit exercise',
      removeExercise: 'Remove exercise',
      assignedAutomatically: 'Assigned automatically',
      automatedEditNote: 'Editing will stop automatic updates for this exercise.',
      weeklyCompletion: 'Weekly completion {{performed}}/{{total}}',
      dailyCompletion: 'Daily completion {{performed}}/{{total}}',
      sets: '{{count}} sets',
      reps: '{{count}} reps',
      holdSec: '{{count}} sec hold',
      removeConfirmTitle: 'Delete exercise',
      save: 'Save',
      cancel: 'Cancel',
      removeConfirmMessage: 'Are you sure you want to delete this exercise?',
      remove: 'Delete',
      fields: {
        sets: 'Sets',
        reps: 'Reps',
        times: 'Times',
        sec: 'sec',
      },
      frequency: {
        everyDay: 'Every day',
        timesADay: '{{count}} times a day',
        timesAWeek: '{{count}} times a week',
      },
      frequencyUnits: {
        day: 'Per day',
        week: 'Per week',
      },
      frequencyUnitOptions: {
        day: 'day',
        week: 'week',
      },
      frequencyUnitsInline: {
        day: 'a day',
        week: 'a week',
      },
    },
  },
};
